module.exports = __webpack_public_path__ + "media/add/wheel-add-02-c893aff7.png";